import { LinkItem } from '@occc/ui-design-system';

const CAMPAIGNS_BASE_URL = '/campaigns';

export const routeCreator = {
  list: () => CAMPAIGNS_BASE_URL,
  update: (id: string) => `${CAMPAIGNS_BASE_URL}/${id}/update`,
  create: () => `${CAMPAIGNS_BASE_URL}/create`,
  details: (id: string) => `${CAMPAIGNS_BASE_URL}/${id}`,
  offerDetails: (id: string, offerId: string) => `${CAMPAIGNS_BASE_URL}/${id}/${offerId}`,
};

export const getCampaignCreatePageHeaderLinks = (name: string): LinkItem[] => [
  {
    to: routeCreator.list(),
    label: 'Campaigns',
  },
  {
    to: routeCreator.create(),
    label: 'Create',
  },
  {
    key: '/campaigns/create/campaign-name',
    label: name ? `${name}` : null,
  },
];

export const getCampaignUpdatePageHeaderLinks = (name: string): LinkItem[] => [
  {
    to: routeCreator.list(),
    label: 'Campaigns',
  },
  {
    key: '/campaigns/update/campaign-name',
    label: `Edit ${name || ''}`,
  },
];
// TODO: should be the same for all breadcrumbs. Move to common
export const errorLabel = { key: 'error', label: 'Something went wrong' };
export const notFoundLabel = { key: 'not-found', label: 'Page Not Found' };
export const loadingLabel = { key: 'loading', label: 'Loading...' };

type GetCampaignPageHeaderLinks = (loading: boolean, error: boolean, name?: string) => LinkItem[];

export const getCampaignPageHeaderLinks: GetCampaignPageHeaderLinks = (loading, error, name) => {
  const links: LinkItem[] = [
    {
      to: routeCreator.list(),
      label: 'Campaigns',
    },
  ];

  if (error) {
    return [...links, errorLabel];
  }
  if (!name) {
    return [...links, loading ? loadingLabel : notFoundLabel];
  }

  return [
    ...links,
    {
      key: '/campaigns/campaign-name',
      label: name,
    },
  ];
};
